/**
 * SDK Configuration
 */

export interface SDKConfig {
  apiKey: string;
  baseUrl?: string;
  customerId?: number;
  devMode?: boolean;
  skipPaymentVerification?: boolean;
  skipPaymentMethod?: boolean; // Skip payment method entirely
  maxRetries?: number; // Maximum number of retries for failed requests
  retryDelay?: number; // Delay in ms between retries
  timeout?: number; // Request timeout in ms
  requestId?: string; // Optional Request ID override
  signature?: string; // Optional Signature override
}

export const DEFAULT_BASE_URL = 'https://reseller-api.ds.network';
export const SANDBOX_BASE_URL = 'https://reseller-api.sandbox.ds.network';

/**
 * Get configuration from environment variables
 */
export function getConfigFromEnv(): Partial<SDKConfig> {
  return {
    apiKey: import.meta.env.VITE_DREAMSCAPE_API_KEY || '',
    baseUrl: (function () {
      let b = import.meta.env.VITE_DREAMSCAPE_API_BASE_URL || DEFAULT_BASE_URL;

      // Force direct API URL for all environments as per user request to remove all proxy layers
      if (import.meta.env.DEV) {
        console.log(`📡 Dreamscape SDK: Dev mode - Using DIRECT API URL: ${b}`);
      } else {
        console.log(`📡 Dreamscape SDK: Production mode - Using DIRECT API URL: ${b}`);
      }

      if (!b.endsWith('/')) b += '/';
      return b;
    })(),
    customerId: import.meta.env.VITE_DREAMSCAPE_CUSTOMER_ID
      ? parseInt(import.meta.env.VITE_DREAMSCAPE_CUSTOMER_ID)
      : undefined,
    devMode: import.meta.env.VITE_DREAMSCAPE_DEV_MODE === 'true',
    skipPaymentVerification: import.meta.env.VITE_DREAMSCAPE_SKIP_PAYMENT === 'true',
    skipPaymentMethod: import.meta.env.VITE_DREAMSCAPE_SKIP_PAYMENT_METHOD === 'true',
    maxRetries: import.meta.env.VITE_DREAMSCAPE_MAX_RETRIES
      ? parseInt(import.meta.env.VITE_DREAMSCAPE_MAX_RETRIES)
      : 3,
    retryDelay: import.meta.env.VITE_DREAMSCAPE_RETRY_DELAY
      ? parseInt(import.meta.env.VITE_DREAMSCAPE_RETRY_DELAY)
      : 1000,
    timeout: import.meta.env.VITE_DREAMSCAPE_TIMEOUT
      ? parseInt(import.meta.env.VITE_DREAMSCAPE_TIMEOUT)
      : 30000,
    requestId: import.meta.env.VITE_DREAMSCAPE_REQUEST_ID,
    signature: import.meta.env.VITE_DREAMSCAPE_SIGNATURE,
  };
}

